import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"
import weekday from "dayjs/plugin/weekday"
import { type ReactNode, useLayoutEffect } from "react"
import { type ConnectedProps, connect } from "react-redux"

import { guessTimezone } from "../containers/Calendar/CalendarPage/components/CalendarAddForms/time.ts"
import { type RootState } from "../store.ts"

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(weekday)
dayjs.extend(customParseFormat)

interface DayjsProps extends ConnectedProps<typeof connector> {
  children: ReactNode
}

const DayjsProvider = ({ userInfo, children }: DayjsProps) => {
  useLayoutEffect(() => {
    const defaultTz = userInfo?.timezone || guessTimezone()

    dayjs.tz.setDefault(defaultTz)
    console.log("Default timezone set to:", defaultTz)
  }, [userInfo?.timezone])

  return <>{children}</>
}

const mapStateToProps = (state: RootState) => ({
  userInfo: state.auth.userInfo
})

const connector = connect(mapStateToProps, null)
export default connector(DayjsProvider)
